export default __webpack_public_path__ + "static/promoteur@2x-e87e2afa71faf4b370d272484b3814cf.png";